export const mobileNumberEntered = {
    event: "mobile_number_entered",
    eventAction: "Mobile_number entered",
    eventCategory: "Challan_Login"
};

export const otpVerification = {
    event: "otp_verification",
    eventAction: "OTP_entered",
    eventCategory: "Challan_Login"
};
